<template>
  <component
    :is="tagName"
    ref="$el"
    v-bind="computedProps">
    <slot v-bind="{ hovered, computedRoute }" />
  </component>
</template>

<script setup>
  const emit = defineEmits([ 'click' ])

  const props = defineProps({
    id: String,
    tag: String,
    disabled: Boolean,
    target: String,
    label: String,
    href: String,
    to: [ String, Object ],
    type: String
  })

  const $el = ref()
  const router = useRouter()

  const tagName = computed(() => {
    if (props.tag) { return props.tag }
    if (!props.to && !props.href) {
      return 'button'
    }
    return !!props.to ? resolveComponent('nuxt-link') : 'a'
  })

  const computedRoute = computed(() => props.to ? router.resolve(props.to) : {})

  const hovered = useElementHover($el)

  const computedProps = computed(() => {
    return {
      ...(props.id ? { id: props.id } : {}),
      // `to` ha la precedenza (tagName diventa nuxt-link): senza il `!props.to`
      // passeremmo a NuxtLink sia `to` che `href`, da cui il warning di Vue
      // "to and href cannot be used together". href vale solo per il tag <a>.
      ...(props.href && !props.to ? { href: props.href, target: '_blank' } : {}),
      ...(props.target ? { target: props.target } : {}),
      ...(props.to ? { to: props.to } : {}),
      ...(props.rel ? { rel: props.rel } : {}),
      ...(props.type ? { type: props.type } : {}),
      ...(props.tagName === 'button' ? { type: 'button', tabindex: 0 } : {}),
      ...(props.label ? { 'aria-label': props.label } : {}),
      ...(props.disabled ? { disabled: true } : {}),
      onClick: () => { emit('click') }
    }
  })
</script>
